<template>
  <div class="list_box">
      <div class="title-box">
        <div class="title">{{ list.name }}</div>
        <div><el-link v-if="list.url" :href="'#'+'/article'+list.url" :underline="false" class="more">更多 +</el-link></div>
      </div>
      <div class="body-box">
        <ul>
          <template v-for="item,index in list.contents" :key="item.id" >
            <li v-if="index <= 6"><el-link :underline="false" :href="'#'+'/article'+list.url+'/'+item.id"><div class="item-icon">◆</div><div class="item" :title="item.subject">{{ item.subject }}</div><div class="created-date">{{ item.created_at }}</div></el-link></li>
          </template>
        </ul>
      </div>
  </div>
</template>
<script>
export default ({
  name: "News",
  props: {
    list: {},
  }
})
</script>

<style scoped>
/deep/ .el-link {
  font-size: 16px;
}
.body-box ul li{
  width: 392px;
  height: 40px;
  line-height: 40px;
  list-style: none;
  border-bottom: 1px solid #E3E3E3;
  /*white-space: nowrap;*/
  /*overflow: hidden;
  text-overflow: ellipsis;*/
}
.body-box ul li:last-child {
  border: none;
}
.item {
  width: 260px;
  margin-left: 5px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-icon {
  width: 15px;
  text-align: right;
  font-size: 12px;
  float: left;
  height: 40px;
  line-height: 35px;
  color: #BC0000;
}
.list_box .body-box ul li div.item:first-child{
  font-weight: bold!important;
}
.body-box ul li:first-child, .body-box ul li:nth-child(2){
  font-weight: bold!important;
  background: #FDF6EC;
  height: 40px;
  line-height: 40px;
  border: none;
}
.created-date {
  width: 100px;
  float: right;
  text-align: right;
}

.list_box {
  width: 386px;
  height: 345px;
  float: left;
}
.title-box {
  width: 392px;
  height: 36px;
  background: #F3F3F3;
  border-bottom: 2px solid #E3E3E3;
  margin-bottom: 10px;
}
.title {
  width: 100px;
  height: 34px;
  text-align: center;
  border-bottom:4px solid #BF2E11;
  float: left;
  color: #BF2E11;
  line-height: 38px;
  font-size: 18px;
  font-weight: bold;
}
.more {
  width: 60px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  float: right;
  font-size: 14px;
}
</style>